import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useParams } from "react-router-dom";

export default function SalesTypeFormPage() {
    const { id } = useParams(); // عند التعديل فقط يظهر
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // جلب البيانات عند التعديل
    useEffect(() => {
        if (!id) return;

        const fetchType = async () => {
            try {
                const res = await backEnd_request.get(`/SalesTypes/${id}`);
                setName(res.data.name || "");
            } catch (err) {
                console.log(err);
                setErrorMessage("فشل جلب بيانات نوع البيع");
            }
        };

        fetchType();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        const payload = { name: name.trim() };

        try {
            if (id) {
                await backEnd_request.post(`/SalesTypes/${id}`, payload);
                navigate("/admin/sales-types-management", {
                    state: { successMessage: "تم تعديل نوع البيع بنجاح ✅" }
                });
            } else {
                await backEnd_request.post("/SalesTypes", payload);
                navigate("/admin/sales-types-management", {
                    state: { successMessage: "تم إضافة نوع البيع بنجاح ✅" }
                });
            }
        } catch (err) {
            console.log(err.response?.data || err);
            setErrorMessage("حدث خطأ أثناء الحفظ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5">
            <h3 className="fw-bold text-primary mb-4">
                {id ? "تعديل نوع البيع" : "إضافة نوع بيع جديد"}
            </h3>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">اسم نوع البيع</label>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <button className="btn btn-primary" disabled={loading}>
                    {loading ? "جارٍ الحفظ..." : id ? "تعديل" : "إضافة"}
                </button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => navigate("/admin/sales-types-management")}
                >
                    إلغاء
                </button>
            </form>
        </div>
    );
}
